<template>
  <div :class="isMax?'isMax':'isMoadl'">
    <div class="center-title">
      <span>{{title}}</span>
      <span v-if="!isMax">
        <svg @click.stop='minOperation' t="1675991873943" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11850" width="22" height="22"><path d="M829.160727 880.360727L584.145455 635.345455a36.212364 36.212364 0 1 1 51.2-51.2l245.015272 245.015272a36.212364 36.212364 0 1 1-51.2 51.2z" fill="#A2A5B4" p-id="11851"></path><path d="M790.109091 612.864h-206.848a36.212364 36.212364 0 0 1 0-72.424727h206.848a36.212364 36.212364 0 0 1 0 72.424727z" fill="#A2A5B4" p-id="11852"></path><path d="M615.936 787.083636v-206.894545a36.212364 36.212364 0 0 0-72.424727 0v206.894545a36.212364 36.212364 0 0 0 72.424727 0z" fill="#A2A5B4" p-id="11853"></path><path d="M182.132364 127.860364l245.015272 245.015272a36.212364 36.212364 0 1 1-51.2 51.2L130.932364 179.060364a36.212364 36.212364 0 1 1 51.2-51.2z" fill="#A2A5B4" p-id="11854"></path><path d="M221.184 395.357091h206.848a36.212364 36.212364 0 0 1 0 72.424727H221.184a36.212364 36.212364 0 0 1 0-72.424727z" fill="#A2A5B4" p-id="11855"></path><path d="M395.357091 221.184v206.848a36.212364 36.212364 0 0 0 72.424727 0V221.184a36.212364 36.212364 0 0 0-72.424727 0z" fill="#A2A5B4" p-id="11856"></path></svg>
        <svg @click.stop='maxOperation' t="1675991924873" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11993" width="22" height="22"><path d="M793.6 847.127273l-179.2-179.2a36.212364 36.212364 0 0 1 51.2-51.2l179.2 179.2a36.212364 36.212364 0 1 1-51.2 51.2z" fill="#A2A5B4" p-id="11994"></path><path d="M830.696727 655.825455v206.848a36.212364 36.212364 0 0 0 72.424728 0v-206.894546a36.212364 36.212364 0 0 0-72.424728 0z" fill="#A2A5B4" p-id="11995"></path><path d="M656.523636 829.998545h206.848a36.212364 36.212364 0 0 1 0 72.378182h-206.848a36.212364 36.212364 0 0 1 0-72.378182zM339.456 392.983273L193.163636 246.690909a36.212364 36.212364 0 1 1 51.2-51.2l146.292364 146.292364a36.212364 36.212364 0 0 1-51.2 51.2z" fill="#A2A5B4" p-id="11996"></path><path d="M370.874182 195.956364H164.026182a36.212364 36.212364 0 0 1 0-72.378182h206.848a36.212364 36.212364 0 0 1 0 72.378182z" fill="#A2A5B4" p-id="11997"></path><path d="M196.701091 370.176V163.281455a36.212364 36.212364 0 0 0-72.424727 0v206.894545a36.212364 36.212364 0 0 0 72.424727 0z" fill="#A2A5B4" p-id="11998"></path><path d="M847.872 233.053091l-179.2 179.2a36.212364 36.212364 0 0 1-51.2-51.2l179.2-179.2a36.212364 36.212364 0 1 1 51.2 51.2z" fill="#A2A5B4" p-id="11999"></path><path d="M656.523636 195.956364h206.848a36.212364 36.212364 0 0 0 0-72.378182h-206.848a36.212364 36.212364 0 0 0 0 72.378182z" fill="#A2A5B4" p-id="12000"></path><path d="M830.696727 370.176V163.281455a36.212364 36.212364 0 0 1 72.424728 0v206.894545a36.212364 36.212364 0 0 1-72.424728 0z" fill="#A2A5B4" p-id="12001"></path><path d="M393.681455 687.243636l-146.245819 146.245819a36.212364 36.212364 0 1 1-51.2-51.2l146.245819-146.245819a36.212364 36.212364 0 0 1 51.2 51.2z" fill="#A2A5B4" p-id="12002"></path><path d="M196.701091 655.825455v206.848a36.212364 36.212364 0 0 1-72.424727 0v-206.894546a36.212364 36.212364 0 0 1 72.424727 0z" fill="#A2A5B4" p-id="12003"></path><path d="M370.874182 829.998545H164.026182a36.212364 36.212364 0 0 0 0 72.378182h206.848a36.212364 36.212364 0 0 0 0-72.378182z" fill="#A2A5B4" p-id="12004"></path></svg>
        <svg @click.stop='closeMoadl' t="1675991965229" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12141" width="22" height="22"><path d="M230.385866 742.382499m25.606007-25.606007l460.776492-460.776492q25.606008-25.606008 51.212016 0l0 0q25.606008 25.606008 0 51.212016l-460.776492 460.776491q-25.606008 25.606008-51.212016 0l0 0q-25.606008-25.606008 0-51.212015Z" fill="#A2A5B4" p-id="12142"></path><path d="M716.801278 768.02142L255.991873 307.212016a36.212364 36.212364 0 0 1 51.212016-51.212016l460.776492 460.776492a36.212364 36.212364 0 0 1-51.212016 51.212015z" fill="#A2A5B4" p-id="12143"></path></svg>
      </span>
    </div>
    <div :class="isShowPdf?'uploadContent':'noUploadContent'">
      <div  class="custormForm" v-if="!loadingEdit">
        <!-- 表单内容 -->
        <div class="container_left" :style="{ height: hHeight  }">
          <a-form :model="ruleForm" :colon= false :rules="rules" ref='modalFormRef' autocomplete="off">
            <!-- 附件 -->
            <div class="custorm-base" v-if="!newData.id">
              <div class="custorm-add-title">
                <svg t="1677131867068" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4052" width="22" height="22"><path d="M608.341333 294.144c14.336-10.709333 34.432-10.709333 50.218667 1.28 14.336 13.354667 14.336 32 0 45.354667l-307.328 284.16c-20.096 17.365333-20.096 48.042667 0 68.053333 18.688 18.645333 51.754667 18.645333 73.258667 0l360.490666-336.170667a115.626667 115.626667 0 0 0 0-170.752c-50.218667-46.634667-133.504-46.634667-183.850666 0l-43.008 39.978667-11.52 10.709333-280.192 264.064c-81.834667 76.032-97.834667 229.973333-20.608 284.714667 77.269333 54.741333 160.853333 89.130667 283.349333 0l311.338667-289.450667c5.76-2.645333 8.618667-6.656 11.52-10.709333a34.773333 34.773333 0 0 1 48.810666 0c14.378667 13.312 14.378667 32 0 45.354667l-2.816 2.602666c-2.816 1.28-5.76 5.333333-8.576 7.978667l-331.306666 304.426667c-114.432 85.205333-253.482667 85.205333-361.088-14.848-107.733333-100.053333-87.168-275.456 20.565333-375.424l334.762667-316.16c77.482667-71.978667 203.946667-71.978667 282.837333 0 77.482667 72.021333 77.482667 189.44 0 262.741333l-361.898667 336.256c-47.36 44.032-124.885333 44.032-170.88 0-47.36-44.032-47.36-116.010667 0-158.72l305.92-285.44z" fill="#333333" p-id="4053"></path></svg>
                <h3>附件</h3>
              </div>
              <div class="custorm-content">
                <a-form-item label="上传简历" >
                  <appendix-upload
                    :oldFileList="resumeUpload.uploadFlie"
                    :fileTips="resumeUpload.uploadType"
                    :fileSize="resumeUpload.uploadSize"
                    :uploadMaxNum="resumeUpload.uploadNum"
                    @fileUploadM="fileUploadM"
                    @rightChaClick="rightChaClick"
                    @handlePreview ='handlePreview'
                    :icon="'only'"
                  ></appendix-upload>
                </a-form-item>
              </div>
            </div>
            <!-- 基本信息 -->
            <div class="custorm-base" v-if="fieldSetList.resume_base.show">
              <div class="custorm-add-title">
                <svg t="1675991572773" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11572" width="22" height="22"><path d="M298.666667 128v64H234.666667a21.333333 21.333333 0 0 0-20.992 17.493333L213.333333 213.333333v640a21.333333 21.333333 0 0 0 17.493334 20.992l3.84 0.341334h554.666666a21.333333 21.333333 0 0 0 20.992-17.493334L810.666667 853.333333V213.333333a21.333333 21.333333 0 0 0-17.493334-20.992L789.333333 192H725.333333V128h64a85.333333 85.333333 0 0 1 85.333334 85.333333v640a85.333333 85.333333 0 0 1-85.333334 85.333334h-554.666666a85.333333 85.333333 0 0 1-85.333334-85.333334V213.333333a85.333333 85.333333 0 0 1 85.333334-85.333333H298.666667z m224 554.666667a32 32 0 1 1 0 64h-192a32 32 0 1 1 0-64h192z m170.666666-170.666667a32 32 0 1 1 0 64h-362.666666a32 32 0 1 1 0-64h362.666666z m0-170.666667a32 32 0 1 1 0 64h-362.666666a32 32 0 0 1 0-64h362.666666zM576 53.333333a85.333333 85.333333 0 0 1 85.333333 85.333334v42.666666a85.333333 85.333333 0 0 1-85.333333 85.333334h-128a85.333333 85.333333 0 0 1-85.333333-85.333334v-42.666666a85.333333 85.333333 0 0 1 85.333333-85.333334h128z m0 64h-128a21.333333 21.333333 0 0 0-20.992 17.493334L426.666667 138.666667v42.666666a21.333333 21.333333 0 0 0 17.493333 20.992l3.84 0.341334h128a21.333333 21.333333 0 0 0 20.992-17.493334L597.333333 181.333333v-42.666666a21.333333 21.333333 0 0 0-17.493333-20.992l-3.84-0.341334z" fill="#333333" p-id="11573"></path></svg>
                <h3>基本信息</h3>
              </div>
              <div class="custorm-content" v-if="!newData.id">
                <a-form-item :name="['resume', 'headPhoto']"  class="imgForm">
                  <template #label>头<i class="space-font" />像</template>
                  <div class="img-box">
                    <img :src ="setPhoto(ruleForm.resume.headPhoto)" />
                    <span @click="closeCropper(true)" class="clickable-txt">上传头像</span>
                  </div>
                </a-form-item>
              </div>
              <div class="custorm-content" :class="{addContent: !isShowPdf}">
                <a-form-item :name="['resume', 'name']"  :rules="fieldSetList.name.notNull?rules.name:[{ required: false }]" v-if="fieldSetList.name.show">
                  <template #label>姓<i class="space-font" />名</template>
                  <a-input autocomplete="new-password" v-model:value="ruleForm.resume.name" placeholder="请输入姓名"  maxlength="15" />
                </a-form-item>
                <a-form-item  :name="['resume', 'sex']"  :rules="fieldSetList.sex.notNull?rules.sex:[{ required: false }]" v-if="fieldSetList.sex.show">
                  <template #label>性<i class="space-font" />别</template>
                  <a-select :getPopupContainer=" triggerNode => {return triggerNode.parentNode }" v-model:value="ruleForm.resume.sex" placeholder="请选择性别" :options="genderList" :field-names="{ label: 'dicValue', value: 'dicKey' }">
                    <template #suffixIcon><caret-down-outlined class="ant-select-suffix"/></template>
                  </a-select>
                </a-form-item>
                <a-form-item label="出生年月" :name="['resume', 'birthDay']"  :rules="fieldSetList.birthDay.notNull?rules.birthDay:[{ required: false }]" v-if="fieldSetList.birthDay.show">
                  <a-date-picker 
                    v-model:value="ruleForm.resume.birthDay"
                    valueFormat="YYYY-MM"
                    placeholder="开始时间" 
                    picker="month"
                    :disabled-date="disabledBase"
                  />
                </a-form-item>
                <a-form-item label="所在城市" :name="['resume', 'cityId']"  :rules="fieldSetList.city.notNull?rules.cityId:[{ required: false }]" v-if="fieldSetList.city.show">
                  <city-list 
                    :oldSelData="ruleForm.resume.city"
                    @searchCityhandle="searchCityhandle" 
                    :selectNum='1'
                  ></city-list>
                </a-form-item>
                <a-form-item label="工作年份" :name="['resume', 'workYears']"  :rules="fieldSetList.workYears.notNull?rules.workYears:[{ required: false }]" v-if="fieldSetList.workYears.show">
                  <a-date-picker 
                    v-model:value="ruleForm.resume.workYears" 
                    valueFormat="YYYY-MM"
                    placeholder="开始时间" 
                    picker="month"
                    :disabled-date="disabledBase"
                  />
                </a-form-item>
                <a-form-item label="婚姻状况" :name="['resume', 'maritalStatus']"  :rules="fieldSetList.maritalStatus.notNull?rules.maritalStatus:[{ required: false }]" v-if="fieldSetList.maritalStatus.show">
                  <a-select :getPopupContainer=" triggerNode => {return triggerNode.parentNode }" v-model:value="ruleForm.resume.maritalStatus" placeholder="请选择婚姻状况" :options="maritalList" :field-names="{ label: 'dicValue', value: 'dicKey' }">
                    <template #suffixIcon><caret-down-outlined class="ant-select-suffix"/></template>
                  </a-select>
                </a-form-item>
                <a-form-item label="毕业院校" :name="['resume', 'school']"  :rules="fieldSetList.school.notNull?rules.school:[{ required: false }]" v-if="fieldSetList.school.show">
                  <a-input v-model:value="ruleForm.resume.school" placeholder="请填写毕业院校" maxlength="100"/>
                </a-form-item>
                <a-form-item label="最高学历" :name="['resume', 'highestEducational']"  :rules="fieldSetList.highestEducational.notNull?rules.highestEducational:[{ required: false }]" v-if="fieldSetList.highestEducational.show">
                  <a-select :getPopupContainer=" triggerNode => {return triggerNode.parentNode }" v-model:value="ruleForm.resume.highestEducational" placeholder="请选择最高学历" :options="eduLevelList" :field-names="{ label: 'dicValue', value: 'dicKey' }">
                    <template #suffixIcon><caret-down-outlined class="ant-select-suffix"/></template>
                  </a-select>
                </a-form-item>
                <a-form-item label="户口地址" :name="['resume', 'placeOfDomicile']"  :rules="fieldSetList.placeOfDomicile.notNull?rules.cityId:[{ required: false }]" v-if="fieldSetList.placeOfDomicile.show">
                  <city-list 
                    :oldSelData="ruleForm.resume.placeOfDomicileList" 
                    @searchCityhandle="searchCityhandle1" 
                    :selectNum='1'
                  ></city-list>
                </a-form-item>
                <a-form-item  :name="['resume', 'nationality']"  :rules="fieldSetList.nationality.notNull?rules.nationality:[{ required: false }]" v-if="fieldSetList.nationality.show">
                  <template #label>国<i class="space-font" />籍</template>
                  <a-input autocomplete="new-password" v-model:value="ruleForm.resume.nationality" placeholder="请填写国籍" maxlength="50"/>
                </a-form-item>
                <a-form-item label="手机号码" class="listForm" :required="fieldSetList.phone.notNull " v-if="fieldSetList.phone.show">
                  <a-form-item  :name="['resume','phones',index]"  :rules="fieldSetList.phone.notNull|| !validater.isEmpty(ruleForm.resume.phones[index])?rules.phones:[{ required: false }]" v-for='(item,index) in ruleForm.resume.phones' :key='index' >
                    <a-input autocomplete="new-password" v-model:value="ruleForm.resume.phones[index]" placeholder="请填写手机号码"  oninput ="value=value.replace(/[^0-9+-]/g,'')" maxlength="20"/>
                    <svg @click="addContact('phones')" v-if="index == 0 && ruleForm.resume.phones.length <5" t="1677057396512" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3199" width="22" height="22"><path d="M512 93.090909a418.909091 418.909091 0 1 1 0 837.818182A418.909091 418.909091 0 0 1 512 93.090909z m0 69.818182a349.090909 349.090909 0 1 0 0 698.181818 349.090909 349.090909 0 0 0 0-698.181818z" fill="#A2A5B4" p-id="3200"></path><path d="M302.545455 477.090909m34.90909 0l349.09091 0q34.909091 0 34.90909 34.909091l0 0q0 34.909091-34.90909 34.909091l-349.09091 0q-34.909091 0-34.90909-34.909091l0 0q0-34.909091 34.90909-34.909091Z" fill="#A2A5B4" p-id="3201"></path><path d="M477.090909 721.454545m0-34.90909l0-349.09091q0-34.909091 34.909091-34.90909l0 0q34.909091 0 34.909091 34.90909l0 349.09091q0 34.909091-34.909091 34.90909l0 0q-34.909091 0-34.909091-34.90909Z" fill="#A2A5B4" p-id="3202"></path></svg>
                    <svg @click="delContact('phones',index)"  v-else t="1677057416787" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3341" width="22" height="22"><path d="M230.385866 742.382499m25.606007-25.606007l460.776492-460.776492q25.606008-25.606008 51.212016 0l0 0q25.606008 25.606008 0 51.212016l-460.776492 460.776491q-25.606008 25.606008-51.212016 0l0 0q-25.606008-25.606008 0-51.212015Z" fill="#A2A5B4" p-id="3342"></path><path d="M716.801278 768.02142L255.991873 307.212016a36.212364 36.212364 0 0 1 51.212016-51.212016l460.776492 460.776492a36.212364 36.212364 0 0 1-51.212016 51.212015z" fill="#A2A5B4" p-id="3343"></path></svg>
                  </a-form-item>
                </a-form-item>
                <a-form-item label="邮箱地址" class="listForm" :required="fieldSetList.mail.notNull" v-if="fieldSetList.mail.show">
                  <a-form-item  :name="['resume','mails', index]"  :rules="fieldSetList.mail.notNull || !validater.isEmpty(ruleForm.resume.mails[index])?rules.mails:[{ required: false }]" v-for='(item,index) in ruleForm.resume.mails' :key='index'>
                    <a-input autocomplete="new-password" v-model:value="ruleForm.resume.mails[index]" placeholder="请填写邮箱地址" maxlength="50" />
                    <svg @click="addContact('mails')" v-if="index == 0 && ruleForm.resume.mails.length <5" t="1677057396512" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3199" width="22" height="22"><path d="M512 93.090909a418.909091 418.909091 0 1 1 0 837.818182A418.909091 418.909091 0 0 1 512 93.090909z m0 69.818182a349.090909 349.090909 0 1 0 0 698.181818 349.090909 349.090909 0 0 0 0-698.181818z" fill="#A2A5B4" p-id="3200"></path><path d="M302.545455 477.090909m34.90909 0l349.09091 0q34.909091 0 34.90909 34.909091l0 0q0 34.909091-34.90909 34.909091l-349.09091 0q-34.909091 0-34.90909-34.909091l0 0q0-34.909091 34.90909-34.909091Z" fill="#A2A5B4" p-id="3201"></path><path d="M477.090909 721.454545m0-34.90909l0-349.09091q0-34.909091 34.909091-34.90909l0 0q34.909091 0 34.909091 34.90909l0 349.09091q0 34.909091-34.909091 34.90909l0 0q-34.909091 0-34.909091-34.90909Z" fill="#A2A5B4" p-id="3202"></path></svg>
                    <svg @click="delContact('mails',index)" v-else t="1677057416787" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3341" width="22" height="22"><path d="M230.385866 742.382499m25.606007-25.606007l460.776492-460.776492q25.606008-25.606008 51.212016 0l0 0q25.606008 25.606008 0 51.212016l-460.776492 460.776491q-25.606008 25.606008-51.212016 0l0 0q-25.606008-25.606008 0-51.212015Z" fill="#A2A5B4" p-id="3342"></path><path d="M716.801278 768.02142L255.991873 307.212016a36.212364 36.212364 0 0 1 51.212016-51.212016l460.776492 460.776492a36.212364 36.212364 0 0 1-51.212016 51.212015z" fill="#A2A5B4" p-id="3343"></path></svg>
                  </a-form-item>
                </a-form-item>
                <a-form-item  :name="['resume', 'qq']"  :rules="fieldSetList.qq.notNull?rules.qq:[{ required: false }]" v-if="fieldSetList.qq.show">
                  <template #label>Q<i class="space-font2" />Q</template>
                  <a-input v-model:value.trim="ruleForm.resume.qq" placeholder="请填写qq" maxlength="15" onkeyup="value=value.replace(/\D/g,'')" />
                </a-form-item>
                <a-form-item  :name="['resume', 'wx']"  :rules="fieldSetList.wx.notNull?rules.wx:[{ required: false }]" v-if="fieldSetList.wx.show">
                  <template #label>微<i class="space-font" />信</template>
                  <a-input v-model:value="ruleForm.resume.wx" placeholder="请填写微信" maxlength="20" oninput ="value=value.replace(/[^a-zA-Z\d_-]/g,'')" />
                </a-form-item>
                <a-form-item label="当前公司"  :name="['resume', 'currentCompany']"  :rules="fieldSetList.currentCompany.notNull?rules.currentCompany:[{ required: false }]" v-if="fieldSetList.currentCompany.show">
                  <a-input autocomplete="new-password" v-model:value="ruleForm.resume.currentCompany" placeholder="请填写当前公司" maxlength="100"/>
                </a-form-item>
                <a-form-item label="目前职位" :name="['resume', 'currentPosition']"  :rules="fieldSetList.currentPosition.notNull?rules.currentPosition:[{ required: false }]" v-if="fieldSetList.currentPosition.show">
                  <a-input v-model:value="ruleForm.resume.currentPosition" placeholder="请填写目前职位" maxlength="40"/>
                </a-form-item>
                <a-form-item label="当前年薪" :required="fieldSetList.currentSalary.notNull" class="salary-box" v-if="fieldSetList.currentSalary.show">
                  <a-form-item :name="['resume', 'currentYearlySalaryType']"  :rules="fieldSetList.currentSalary.notNull ||ruleForm.resume.currentYearlySalary?rules.currentYearlySalaryType:[{ required: false }]">
                    <a-select :getPopupContainer=" triggerNode => {return triggerNode.parentNode }" v-model:value="ruleForm.resume.currentYearlySalaryType" placeholder="请选择年薪类型" :options="salaryList" :field-names="{ label: 'dicValue', value: 'dicKey' }">
                      <template #suffixIcon><caret-down-outlined class="ant-select-suffix"/></template>
                    </a-select>
                  </a-form-item>
                  <a-form-item :name="['resume', 'currentYearlySalary']"  :rules="fieldSetList.currentSalary.notNull ||ruleForm.resume.currentYearlySalaryType ||ruleForm.resume.currentYearlySalary?rules.currentYearlySalary:[{ required: false }]">
                    <a-input v-model:value="ruleForm.resume.currentYearlySalary" placeholder="请填写当前年薪"  maxlength="7"/><span class="right_text">万</span>
                  </a-form-item>
                </a-form-item>
                <a-form-item label="期望城市" :name="['resume', 'expectCityIds']"  :rules="fieldSetList.expectCity.notNull?rules.expectCity:[{ required: false }]" v-if="fieldSetList.expectCity.show">
                  <city-list 
                    :oldSelData="ruleForm.resume.expectCities" 
                    @searchCityhandle="searchCityhandle2" 
                    :selectNum='3'
                  ></city-list>
                </a-form-item>
                <a-form-item label="简历标签" :name="['resume', 'tags']" :rules="fieldSetList.tags.notNull?rules.tags:[{ required: false }]" v-if="fieldSetList.tags.show">
                  <div class="tag-box">
                    <a-tag closable @close="detLabel(index)" v-for="(item,index) in ruleForm.resume.tags" :key='index' :id="`tag${index}`" :title="item"><span>{{item}}</span></a-tag>
                    <a-input v-if="ruleForm.resume.tags.length < 300" v-model:value="label" @pressEnter="addLabel" placeholder='回车添加标签' maxlength="20"></a-input>
                  </div>
                </a-form-item>
              </div>
            </div>
            <!-- 工作经历 -->
            <div class="custorm-base" v-if="fieldSetList.resume_work_experience.show">
              <div class="custorm-add-title">
                <svg t="1677131656775" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3482" width="22" height="22"><path d="M948.053333 363.178667a42.666667 42.666667 0 0 1-14.848 14.805333l-377.514666 224.981333a85.333333 85.333333 0 0 1-87.381334 0L90.794667 378.026667a42.666667 42.666667 0 0 1 0-73.301334l377.514666-224.981333a85.333333 85.333333 0 0 1 87.381334 0l377.514666 224.981333a42.666667 42.666667 0 0 1 14.805334 58.453334z m-78.336-21.888l-346.794666-206.634667a21.333333 21.333333 0 0 0-18.346667-1.664l-3.498667 1.706667-346.794666 206.592 346.794666 206.72a21.333333 21.333333 0 0 0 18.346667 1.664l3.498667-1.706667L869.717333 341.333333z" fill="#333333" p-id="3483"></path><path d="M902.698667 497.066667a32 32 0 0 1 35.626666 53.034666l-3.626666 2.432-385.28 222.464a74.666667 74.666667 0 0 1-68.437334 3.242667l-6.4-3.370667-382.933333-222.378666a32 32 0 0 1 28.245333-57.301334l3.925334 1.92 382.890666 222.421334a10.666667 10.666667 0 0 0 8.106667 1.109333l2.56-1.066667 385.28-222.506666z" fill="#333333" p-id="3484"></path><path d="M902.698667 667.733333a32 32 0 0 1 35.626666 53.034667l-3.626666 2.432-385.28 222.464a74.666667 74.666667 0 0 1-68.437334 3.242667l-6.4-3.370667-382.933333-222.378667a32 32 0 0 1 28.245333-57.301333l3.925334 1.92 382.890666 222.421333a10.666667 10.666667 0 0 0 8.106667 1.109334l2.56-1.066667 385.28-222.506667z" fill="#333333" p-id="3485"></path></svg>
                <h3>工作经历</h3>
              </div>
              <div v-for="(item,index) in ruleForm.works" :key='item.id'>
                <div class="custorm-content" :class="{addContent: !isShowPdf}">
                  <a-form-item label="公司名称" :name="['works', index, 'companyName']" :rules="fieldSetList.companyNameOfWorkExperience.notNull?rules.companyName:[{ required: false }]" v-if="fieldSetList.companyNameOfWorkExperience.show">
                    <a-input autocomplete="new-password" v-model:value="item.companyName" placeholder="请填写公司名称" maxlength="100"/>
                  </a-form-item>
                  <a-form-item label="公司行业" :name="['works', index, 'companyIndustryId']" :rules="fieldSetList.companyIndustry.notNull?rules.companyIndustry:[{ required: false }]" v-if="fieldSetList.companyIndustry.show">
                    <indust-type 
                      :selecNum='1'
                      :oldIndstry="item.companyIndustryList" 
                      @searchIndustTypehandle="val=>searchIndusthandle(val,index)"
                    ></indust-type>
                  </a-form-item>
                  <a-form-item label="任职时间" :required="fieldSetList.employmentTime.notNull"  class="timeForm" v-if="fieldSetList.employmentTime.show">
                    <a-form-item :name="['works', index, 'startDate']" :rules="fieldSetList.employmentTime.notNull ||(!validater.isEmpty(item.endDate) ||item.toCurrent )?rules.startDate:[{ required: false }]">
                      <a-date-picker 
                        v-model:value="item.startDate" 
                        valueFormat="YYYY-MM"
                        placeholder="开始时间" 
                        picker="month"
                        :disabled-date="disabledStartDate"
                        @openChange="openChange(item)"
                      />
                    </a-form-item>
                    <span class="time-range">至</span>
                    <a-form-item class="mr12" :name="['works', index, 'endDate']" :rules="(fieldSetList.employmentTime.notNull || !validater.isEmpty(item.startDate))&& !item.toCurrent?rules.endDate:[{ required: false }]" :class="item.toCurrent?'clearError':''">
                      <a-date-picker 
                        v-model:value="item.endDate" 
                        valueFormat="YYYY-MM"
                        placeholder="结束时间" 
                        picker="month"
                        :disabled-date="disabledEndDate"
                        @openChange="openChange(item)"
                        :disabled="item.toCurrent"
                      />
                    </a-form-item>
                    <a-form-item :name="['works', index, 'toCurrent']">
                      <a-checkbox v-model:checked="item.toCurrent" class="details-checkbox" @click="changeEndDate(item)" >在职</a-checkbox>
                    </a-form-item>
                  </a-form-item>
                  <a-form-item label="所在部门" :name="['works', index, 'department']" :rules="fieldSetList.department.notNull?rules.department:[{ required: false }]" v-if="fieldSetList.department.show">
                    <a-input v-model:value="item.department" placeholder="请填写所在部门" maxlength="30"/>
                  </a-form-item>
                  <a-form-item label="职位名称" :name="['works', index, 'positionName']" :rules="fieldSetList.positionNameOfWorkExperience.notNull?rules.positionName:[{ required: false }]" v-if="fieldSetList.positionNameOfWorkExperience.show">
                    <a-input v-model:value="item.positionName" placeholder="请填写职位名称" maxlength="40"/>
                  </a-form-item>
                  <a-form-item label="职位类别" :name="['works', index, 'professionCategoryId']" :rules="fieldSetList.professionCategory.notNull?rules.professionCategoryId:[{ required: false }]" v-if="fieldSetList.professionCategory.show">
                    <job-category 
                      :selecNum='1' 
                      :oldJobCategory="item.professionCategoryList" 
                      @searchJobTypehandle="(val)=>searchTypehandle(val,index)" 
                    />
                  </a-form-item>
                  <a-form-item label="下属人数" :name="['works', index, 'underlingNumber']" :rules="fieldSetList.underlingNumber.notNull?rules.underlingNumber:[{ required: false }]" v-if="fieldSetList.underlingNumber.show">
                    <a-input-number v-model:value="item.underlingNumber" placeholder="请填写下属人数" min="0" max="999999999" :precision="0"/>
                  </a-form-item>
                  <a-form-item label="汇报对象" :name="['works', index, 'reporter']" :rules="fieldSetList.reporter.notNull?rules.reporter:[{ required: false }]" v-if="fieldSetList.reporter.show">
                    <a-input v-model:value="item.reporter" placeholder="请填写汇报对象" maxlength="15"/>
                  </a-form-item>
                </div>
                <div class="custorm-content">
                  <a-form-item label="职责描述" :name="['works', index, 'responsibilityDescription']" :rules="fieldSetList.responsibilityDescription.notNull?rules.responsibilityDescription:[{ required: false }]" v-if="fieldSetList.responsibilityDescription.show">
                    <a-textarea v-model:value="item.responsibilityDescription" placeholder="请填写职责描述" maxlength="5000" :auto-size="{ minRows: 3, maxRows: 5 }" />
                  </a-form-item>
                  <a-form-item label="公司介绍"  :name="['works', index, 'companyIntroduce']" :rules="fieldSetList.companyIntroduce.notNull?rules.companyIntroduce:[{ required: false }]" v-if="fieldSetList.companyIntroduce.show">
                    <a-textarea v-model:value="item.companyIntroduce" placeholder="请填写公司介绍" maxlength="5000" :auto-size="{ minRows: 3, maxRows: 5 }" />
                  </a-form-item>
                  <a-form-item label="工作内容"  :name="['works', index, 'workContent']" :rules="fieldSetList.workContent.notNull?rules.workContent:[{ required: false }]"  v-if="fieldSetList.workContent.show">
                    <a-textarea v-model:value="item.workContent" placeholder="请填写工作内容" maxlength="5000" :auto-size="{ minRows: 3, maxRows: 5 }" />
                  </a-form-item>
                  <a-form-item label="工作业绩"  :name="['works', index, 'workPerformance']" :rules="fieldSetList.workPerformance.notNull?rules.workPerformance:[{ required: false }]" v-if="fieldSetList.workPerformance.show">
                    <a-textarea v-model:value="item.workPerformance" placeholder="请填写工作业绩" maxlength="5000" :auto-size="{ minRows: 3, maxRows: 5 }" />
                  </a-form-item>
                  <a-form-item label="离职原因"  :name="['works', index, 'leaveReason']" :rules="fieldSetList.leaveReason.notNull?rules.leaveReason:[{ required: false }]" v-if="fieldSetList.leaveReason.show">
                    <a-textarea v-model:value="item.leaveReason" placeholder="请填写离职原因" maxlength="5000" :auto-size="{ minRows: 3, maxRows: 5 }" />
                  </a-form-item>
                </div>
                <div class="delete-box"><a-button class="deleteBtn" @click="delExperience(index,'works')">删除</a-button></div>
              </div>
              <div class="add-box" @click="addExperience('works')">
                <svg t="1677050840253" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3023" width="22" height="22"><path d="M512 93.090909a418.909091 418.909091 0 1 1 0 837.818182A418.909091 418.909091 0 0 1 512 93.090909z m0 69.818182a349.090909 349.090909 0 1 0 0 698.181818 349.090909 349.090909 0 0 0 0-698.181818z" fill="#507AFD" p-id="3024"></path><path d="M302.545455 477.090909m34.90909 0l349.09091 0q34.909091 0 34.90909 34.909091l0 0q0 34.909091-34.90909 34.909091l-349.09091 0q-34.909091 0-34.90909-34.909091l0 0q0-34.909091 34.90909-34.909091Z" fill="#507AFD" p-id="3025"></path><path d="M477.090909 721.454545m0-34.90909l0-349.09091q0-34.909091 34.909091-34.90909l0 0q34.909091 0 34.909091 34.90909l0 349.09091q0 34.909091-34.909091 34.90909l0 0q-34.909091 0-34.909091-34.90909Z" fill="#507AFD" p-id="3026"></path></svg>
                添加工作经历
              </div>
            </div>
            <!-- 项目经历 -->
            <div class="custorm-base" v-if="fieldSetList.resume_project_experience.show">
              <div class="custorm-add-title">
                <svg t="1677131711300" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3624" width="22" height="22"><path d="M448 288m32 0l213.333333 0q32 0 32 32l0 0q0 32-32 32l-213.333333 0q-32 0-32-32l0 0q0-32 32-32Z" fill="#333333" p-id="3625"></path><path d="M448 480m32 0l213.333333 0q32 0 32 32l0 0q0 32-32 32l-213.333333 0q-32 0-32-32l0 0q0-32 32-32Z" fill="#333333" p-id="3626"></path><path d="M448 672m32 0l213.333333 0q32 0 32 32l0 0q0 32-32 32l-213.333333 0q-32 0-32-32l0 0q0-32 32-32Z" fill="#333333" p-id="3627"></path><path d="M362.666667 320m-42.666667 0a42.666667 42.666667 0 1 0 85.333333 0 42.666667 42.666667 0 1 0-85.333333 0Z" fill="#333333" p-id="3628"></path><path d="M362.666667 512m-42.666667 0a42.666667 42.666667 0 1 0 85.333333 0 42.666667 42.666667 0 1 0-85.333333 0Z" fill="#333333" p-id="3629"></path><path d="M362.666667 704m-42.666667 0a42.666667 42.666667 0 1 0 85.333333 0 42.666667 42.666667 0 1 0-85.333333 0Z" fill="#333333" p-id="3630"></path><path d="M794.069333 85.333333C838.570667 85.333333 874.666667 120.064 874.666667 162.901333v698.197334C874.666667 903.936 838.570667 938.666667 794.069333 938.666667H229.973333C185.429333 938.666667 149.333333 903.936 149.333333 861.098667V162.901333C149.333333 120.064 185.429333 85.333333 229.930667 85.333333H794.026667z m0 58.197334H229.973333a19.968 19.968 0 0 0-19.84 15.872l-0.298666 3.498666v698.197334a19.626667 19.626667 0 0 0 16.512 19.072l3.626666 0.298666H794.026667c9.898667 0 18.133333-6.826667 19.84-15.872l0.298666-3.498666V162.901333a19.626667 19.626667 0 0 0-16.512-19.072l-3.626666-0.298666z" fill="#333333" p-id="3631"></path></svg>
                <h3>项目经历</h3>
              </div>
              <div v-for="(item,index) in ruleForm.projects" :key='item.id'>
                <div class="custorm-content" :class="{addContent: !isShowPdf}">
                  <a-form-item label="项目名称" :name="['projects', index, 'projectName']" :rules="fieldSetList.projectName.notNull?rules.projectName:[{ required: false }]" v-if="fieldSetList.projectName.show">
                    <a-input v-model:value="item.projectName" placeholder="请填写项目名称" maxlength="40"/>
                  </a-form-item>
                  <a-form-item label="公司名称" :name="['projects', index, 'companyName']" :rules="fieldSetList.companyNameOfProjectExperience.notNull?rules.companyName:[{ required: false }]" v-if="fieldSetList.companyNameOfProjectExperience.show">
                    <a-input autocomplete="new-password" v-model:value="item.companyName" placeholder="请选择公司名称" maxlength="100"/>
                  </a-form-item>
                  <a-form-item label="职位名称" :name="['projects', index, 'position']" :rules="fieldSetList.positionNameOfProjectExperience.notNull?rules.positionName:[{ required: false }]" v-if="fieldSetList.positionNameOfProjectExperience.show">
                    <a-input v-model:value="item.position" placeholder="请填写职位名称" maxlength="40"/>
                  </a-form-item>
                  <a-form-item label="项目时间" :required="fieldSetList.projectTime.notNull" class="timeForm" v-if="fieldSetList.projectTime.show">
                    <a-form-item :name="['projects', index, 'startDate']" :rules="fieldSetList.projectTime.notNull ||(!validater.isEmpty(item.endDate) ||item.toCurrent )?rules.startDate:[{ required: false }]" >
                      <a-date-picker 
                        v-model:value="item.startDate" 
                        valueFormat="YYYY-MM"
                        placeholder="开始时间" 
                        picker="month"
                        :disabled-date="disabledStartDate"
                        @openChange="openChange(item)"
                      />
                    </a-form-item>
                    <span class="time-range">至</span>
                    <a-form-item class="mr12" :name="['projects', index, 'endDate']" :rules="(fieldSetList.projectTime.notNull|| !validater.isEmpty(item.startDate)) && !item.toCurrent ?rules.endDate:[{ required: false }]" :class="item.toCurrent?'clearError':''">
                      <a-date-picker 
                        v-model:value="item.endDate" 
                        valueFormat="YYYY-MM"
                        placeholder="结束时间" 
                        picker="month"
                        :disabled-date="disabledEndDate"
                        @openChange="openChange(item)"
                        :disabled="item.toCurrent"
                      />

                    </a-form-item>
                    <a-form-item :name="['projects', index, 'toCurrent']">
                      <a-checkbox v-model:checked="item.toCurrent" class="details-checkbox" @click="changeEndDate(item)">至今</a-checkbox>
                    </a-form-item>
                  </a-form-item>
                </div>
                <div class="custorm-content">
                  <a-form-item label="项目介绍" :name="['projects', index, 'projectIntroduce']" :rules="fieldSetList.projectIntroduce.notNull?rules.projectIntroduce:[{ required: false }]" v-if="fieldSetList.projectIntroduce.show">
                    <a-textarea v-model:value="item.projectIntroduce" placeholder="请填写项目介绍" maxlength="5000" :auto-size="{ minRows: 3, maxRows: 5 }" />
                  </a-form-item>
                  <a-form-item label="项目职责"  :name="['projects', index, 'projectResponsibility']" :rules="fieldSetList.projectResponsibility.notNull?rules.projectResponsibility:[{ required: false }]" v-if="fieldSetList.projectResponsibility.show">
                    <a-textarea v-model:value="item.projectResponsibility" placeholder="请填写项目职责" maxlength="5000" :auto-size="{ minRows: 3, maxRows: 5 }" />
                  </a-form-item>
                  <a-form-item label="项目业绩"  :name="['projects', index, 'projectPerformance']" :rules="fieldSetList.projectPerformance.notNull?rules.projectPerformance:[{ required: false }]"  v-if="fieldSetList.projectPerformance.show">
                    <a-textarea v-model:value="item.projectPerformance" placeholder="请填写项目业绩" maxlength="5000" :auto-size="{ minRows: 3, maxRows: 5 }" />
                  </a-form-item>
                </div>
                <div class="delete-box"><a-button class="deleteBtn" @click="delExperience(index,'projects')">删除</a-button></div>
              </div>
              <div class="add-box" @click="addExperience('projects')">
                <svg t="1677050840253" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3023" width="22" height="22"><path d="M512 93.090909a418.909091 418.909091 0 1 1 0 837.818182A418.909091 418.909091 0 0 1 512 93.090909z m0 69.818182a349.090909 349.090909 0 1 0 0 698.181818 349.090909 349.090909 0 0 0 0-698.181818z" fill="#507AFD" p-id="3024"></path><path d="M302.545455 477.090909m34.90909 0l349.09091 0q34.909091 0 34.90909 34.909091l0 0q0 34.909091-34.90909 34.909091l-349.09091 0q-34.909091 0-34.90909-34.909091l0 0q0-34.909091 34.90909-34.909091Z" fill="#507AFD" p-id="3025"></path><path d="M477.090909 721.454545m0-34.90909l0-349.09091q0-34.909091 34.909091-34.90909l0 0q34.909091 0 34.909091 34.90909l0 349.09091q0 34.909091-34.909091 34.90909l0 0q-34.909091 0-34.909091-34.90909Z" fill="#507AFD" p-id="3026"></path></svg>
                添加项目经历
              </div>
            </div>
            <!-- 教育经历 -->
            <div class="custorm-base" v-if="fieldSetList.resume_edu_experience.show">
              <div class="custorm-add-title">
                <svg t="1677131736847" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3770" width="22" height="22"><path d="M904.448 436.096c18.816-11.008 29.738667-28.117333 29.738667-46.976 0-18.858667-10.794667-35.968-29.738667-46.976L559.189333 140.373333c-28.202667-16.554667-70.656-16.554667-98.986666 0l-345.173334 201.728c-18.901333 11.008-29.696 28.117333-29.696 46.933334 0 18.901333 10.794667 36.010667 29.696 47.018666l92.373334 54.058667 1.024 274.474667a89.088 89.088 0 0 0 53.930666 81.450666A610.517333 610.517333 0 0 0 505.514667 896a594.816 594.816 0 0 0 259.968-59.562667c24.234667-11.861333 39.765333-36.224 40.106666-63.018666l2.218667-280.576 96.64-56.746667z m-411.306667-240.469333a40.661333 40.661333 0 0 1 33.28 0l331.008 193.322666-331.050666 193.28a40.661333 40.661333 0 0 1-33.28 0l-230.954667-134.613333a32.426667 32.426667 0 0 0-12.714667-7.509333L162.005333 389.12l331.093334-193.493333z m247.594667 577.109333c0 2.56-1.408 4.864-3.669333 6.016a523.093333 523.093333 0 0 1-231.552 53.077333 545.152 545.152 0 0 1-217.258667-44.586666 24.96 24.96 0 0 1-14.933333-22.869334l-0.938667-236.288 187.818667 109.994667a105.344 105.344 0 0 0 99.114666 0l183.296-107.136-1.877333 241.792z" fill="#333333" p-id="3771"></path><path d="M900.693333 468.224a32.554667 32.554667 0 0 0-22.869333 9.386667 31.914667 31.914667 0 0 0-9.472 22.698666v278.058667c0.64 17.28 14.933333 30.933333 32.426667 30.933333 17.408 0 31.744-13.653333 32.384-30.933333v-278.058667a32.256 32.256 0 0 0-32.426667-32.085333z" fill="#333333" p-id="3772"></path></svg>
                <h3>教育经历</h3>
              </div>
              <div v-for="(item,index) in ruleForm.educations" :key='item.id'>
                <div class="custorm-content" :class="{addContent: !isShowPdf}">
                  <a-form-item label="学校名称" :name="['educations', index, 'schoolName']" :rules="fieldSetList.schoolName.notNull?rules.schoolName:[{ required: false }]" v-if="fieldSetList.schoolName.show">
                    <a-input v-model:value="item.schoolName" placeholder="请填写学校名称" maxlength="100"/>
                  </a-form-item>
                  <a-form-item label="学校类型" :name="['educations', index, 'schoolType']" :rules="fieldSetList.schoolType.notNull?rules.schoolType:[{ required: false }]" v-if="fieldSetList.schoolType.show">
                    <a-select :getPopupContainer=" triggerNode => {return triggerNode.parentNode }" v-model:value="item.schoolType" placeholder="请选择学校类型" :options="schoolList" :field-names="{ label: 'dicValue', value: 'dicKey' }">
                      <template #suffixIcon><caret-down-outlined class="ant-select-suffix"/></template>
                    </a-select>
                  </a-form-item>
                  <a-form-item label="专业名称" :name="['educations', index, 'majorName']" :rules="fieldSetList.majorName.notNull?rules.majorName:[{ required: false }]" v-if="fieldSetList.majorName.show">
                    <a-input v-model:value="item.majorName" placeholder="请填写专业名称" maxlength="50"/>
                  </a-form-item>
                  <a-form-item :name="['educations', index, 'educational']" :rules="fieldSetList.educational.notNull?rules.educational:[{ required: false }]" class="eduForm" v-if="fieldSetList.educational.show">
                    <template #label>学<i class="space-font" />历</template>
                    <a-select :getPopupContainer=" triggerNode => {return triggerNode.parentNode }" class="mr12" v-model:value="item.educational" placeholder="请选择学历" :options="eduLevelList1" :field-names="{ label: 'dicValue', value: 'dicKey' }">
                      <template #suffixIcon><caret-down-outlined class="ant-select-suffix"/></template>
                    </a-select>
                    <a-radio-group v-model:value="item.recruitmentType" name="radioGroup" class="details-radio">
                      <a-radio :value=1>统招</a-radio>
                      <a-radio :value=0>非统招</a-radio>
                    </a-radio-group>
                  </a-form-item>
                  <a-form-item label="就读时间" :required="fieldSetList.studyingTime.notNull" class="timeForm" v-if="fieldSetList.studyingTime.show">
                    <a-form-item :name="['educations', index, 'startDate']" :rules="fieldSetList.studyingTime.notNull||(!validater.isEmpty(item.endDate) ||item.toCurrent )?rules.startDate:[{ required: false }]">
                      <a-date-picker 
                        v-model:value="item.startDate" 
                        valueFormat="YYYY-MM"
                        placeholder="开始时间" 
                        picker="month"
                        :disabled-date="disabledStartDate"
                        @openChange="openChange(item)"
                      />
                    </a-form-item>
                    <span class="time-range">至</span>
                    <a-form-item class="mr12" :name="['educations', index, 'endDate']" :rules="(fieldSetList.studyingTime.notNull|| !validater.isEmpty(item.startDate)) && !item.toCurrent?rules.endDate:[{ required: false }]" :class="item.toCurrent?'clearError':''">
                      <a-date-picker 
                        v-model:value="item.endDate" 
                        valueFormat="YYYY-MM"
                        placeholder="结束时间" 
                        picker="month"
                        :disabled-date="disabledEndDate"
                        @openChange="openChange(item)"
                        :disabled="item.toCurrent"
                      />
                    </a-form-item>
                    
                    <a-form-item :name="['educations', index, 'toCurrent']">
                      <a-checkbox v-model:checked="item.toCurrent" class="details-checkbox" @click="changeEndDate(item)">在读</a-checkbox>
                    </a-form-item>
                  </a-form-item>
                </div>
                <div class="custorm-content">
                  <a-form-item label="教育备注" :name="['educations', index, 'remark']" :rules="fieldSetList.educationalRemark.notNull?rules.remark:[{ required: false }]" v-if="fieldSetList.educationalRemark.show">
                    <a-textarea v-model:value="item.remark" placeholder="请填写教育备注" maxlength="500" :auto-size="{ minRows: 3, maxRows: 5 }" />
                  </a-form-item>
                </div>
                <div class="delete-box"><a-button class="deleteBtn" @click="delExperience(index,'educations')">删除</a-button></div>
              </div>
              <div class="add-box" @click="addExperience('educations')">
                <svg t="1677050840253" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3023" width="22" height="22"><path d="M512 93.090909a418.909091 418.909091 0 1 1 0 837.818182A418.909091 418.909091 0 0 1 512 93.090909z m0 69.818182a349.090909 349.090909 0 1 0 0 698.181818 349.090909 349.090909 0 0 0 0-698.181818z" fill="#507AFD" p-id="3024"></path><path d="M302.545455 477.090909m34.90909 0l349.09091 0q34.909091 0 34.90909 34.909091l0 0q0 34.909091-34.90909 34.909091l-349.09091 0q-34.909091 0-34.90909-34.909091l0 0q0-34.909091 34.90909-34.909091Z" fill="#507AFD" p-id="3025"></path><path d="M477.090909 721.454545m0-34.90909l0-349.09091q0-34.909091 34.909091-34.90909l0 0q34.909091 0 34.909091 34.90909l0 349.09091q0 34.909091-34.909091 34.90909l0 0q-34.909091 0-34.909091-34.90909Z" fill="#507AFD" p-id="3026"></path></svg>
                添加教育经历
              </div>
            </div>
            <!-- 个人特色 -->
            <div class="custorm-base" v-if="fieldSetList.resume_personal_characteristic.show">
              <div class="custorm-add-title">
                <svg t="1677131769719" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3911" width="22" height="22"><path d="M490.666667 59.733333a362.666667 362.666667 0 0 1 307.2 555.477334l124.8 165.589333a8.533333 8.533333 0 0 1-5.418667 13.568l-146.901333 23.808a8.533333 8.533333 0 0 0-6.314667 4.736l-65.28 136.277333a8.533333 8.533333 0 0 1-14.506667 1.450667l-132.821333-176.213333a21.418667 21.418667 0 0 1-2.389333-4.053334 362.325333 362.325333 0 0 1-101.973334 2.133334l-1.28 1.962666-132.821333 176.213334a8.533333 8.533333 0 0 1-14.506667-1.408l-64.341333-133.034667a8.533333 8.533333 0 0 0-6.144-4.693333l-148.352-26.922667a8.533333 8.533333 0 0 1-5.290667-13.568l116.48-154.538667A362.666667 362.666667 0 0 1 490.666667 59.733333zM232.661333 677.290667l-53.077333 70.4 59.818667 10.922666a72.533333 72.533333 0 0 1 48.64 33.066667l3.712 6.698667 24.746666 51.2 52.48-69.546667-52.010666-39.168a363.946667 363.946667 0 0 1-84.181334-63.488l-0.128-0.085333z m531.882667 0l-136.32 102.698666 52.224 69.248 25.856-53.973333 3.413333-6.229333a72.533333 72.533333 0 0 1 50.389334-34.005334l56.149333-9.130666-51.712-68.650667zM490.666667 123.733333a298.666667 298.666667 0 0 0-215.296 505.642667l76.074666 57.344A298.666667 298.666667 0 1 0 490.666667 123.733333z" fill="#333333" p-id="3912"></path><path d="M490.666667 528.682667l-125.397334 66.304 24.32-139.733334-101.802666-98.773333 140.373333-20.053333L490.666667 209.066667l62.464 127.317333 140.416 20.053333-101.802667 98.816 24.32 139.733334z" fill="#333333" p-id="3913"></path></svg>
                <h3>个人特色</h3>
              </div>
              <div class="custorm-content">
                <a-form-item label="自我评价" :name="['personalFeature', 'selfAppraisal']" :rules="fieldSetList.selfAppraisal.notNull?rules.selfAppraisal:[{ required: false }]" v-if="fieldSetList.selfAppraisal.show">
                  <a-textarea v-model:value="ruleForm.personalFeature.selfAppraisal" placeholder="请填写自我评价" maxlength="500" :auto-size="{ minRows: 3, maxRows: 5 }" />
                </a-form-item>
                <a-form-item label="技能描述" :name="['personalFeature', 'skillDescription']" :rules="fieldSetList.skillDescription.notNull?rules.skillDescription:[{ required: false }]" v-if="fieldSetList.skillDescription.show">
                  <a-textarea v-model:value="ruleForm.personalFeature.skillDescription" placeholder="请填写技能描述" maxlength="500" :auto-size="{ minRows: 3, maxRows: 5 }" />
                </a-form-item>
              </div>
            </div>
            <div class="fromLast" v-if="!newData.id">
              <a-form-item  label="加入项目" :name="['joinProject', 'projectId']">
                <a-select 
                  :getPopupContainer=" triggerNode => {return triggerNode.parentNode }"
                  v-model:value="ruleForm.joinProject.projectId" 
                  placeholder="请选择要加入的项目" 
                  @click="getProject"
                  @search='SearchProject'
                  show-search
                  :filter-option="false">
                  <a-select-option  v-for="item in positionList" :key='item.projectId' :value='item.projectId' :label="`${item.projectTitle}${item.customerName}`">
                    #{{item.projectId}} {{item.projectTitle}}-<span class="custmoer-txt">#{{item.customerNo}}{{item.customerName}}</span>-{{item.createName}}
                  </a-select-option>
                  <template #suffixIcon><caret-down-outlined class="ant-select-suffix"/></template>
                </a-select>
              </a-form-item>
              <a-form-item  label="加入原因" :rules="ruleForm.joinProject.projectId?rules.joinProject.remark:[{ required: false }]" :name="['joinProject', 'remark']">
                <a-textarea v-model:value="ruleForm.joinProject.remark" placeholder="请填写加入原因" maxlength="2000" :auto-size="{ minRows: 3, maxRows: 5 }" :disabled="!ruleForm.joinProject.projectId"/>
              </a-form-item>
            </div>
          </a-form>
        </div>
        
        <!-- 右侧简历 -->
        <div v-if="isShowPdf" class="container_right" :style="{ height: hHeight  }">
          <div @click="isShowPdf =!isShowPdf" class="pdfBtn">关闭</div>
          <iframe :src="previewUrl" width="100%" height="100%" />
        </div>
      </div>
      <!-- 按钮 -->
      <div class="btn-item" >
        <a-checkbox v-model:checked="openDetails">保存后打开详情</a-checkbox>
        <a-button class="mainBtn" type="primary"  @click="handleOk" :loading='loading'>保存</a-button>
      </div>
    </div>
    <!-- 头像裁剪 -->
    <avatar-cropper
      :uploadVisible="uploadVisible"
      @headUpload ='headUpload'
      @closeCropper = 'closeCropper'
      v-if="uploadVisible"
    ></avatar-cropper>
  </div>
</template>

<script>
import {
  CaretDownOutlined,
} from "@ant-design/icons-vue";
import {useRouter} from 'vue-router'
import { defineComponent, toRefs,reactive,onMounted,nextTick,getCurrentInstance,onUnmounted} from 'vue';
import { message } from "ant-design-vue";
import getMixin from "@/composables/personnel"
import getAdd from "@/composables/add"
import {setPhoto} from "@/composables/base"
import AvatarCropper from "@/components/upload/avatarCropper.vue";
import AppendixUpload from '@/components/upload/appendix.vue'
import JobCategory from '@/components/search/jobCategory.vue'
import CityList from '@/components/search/city.vue'
import IndustType from '@/components/search/indust.vue'
import {setFileUrl} from "@/composables/comm"
import { validater } from "@/utils/validater.js"
import {
  resumeAnalysisAPI,//简历解析
  addResumeAPI,//简历添加
  updateResumeAPI,//简历修改
} from "@/api/resume"
import {
  projectBoxListApi,//职位下拉框
} from "@/api/position"
export default defineComponent({
  props:['addPar'],
  components:{
    CaretDownOutlined,
    AvatarCropper,
    AppendixUpload,
    JobCategory,
    CityList,
    IndustType,
  },
  setup(props) {
    var data = reactive({
      loading:false,
      loadingEdit:true,
      ruleForm:{
        resume: {
          name:'',
          phones: [null],
          mails: [null],
          tags: [],
          expectCityIds:[],
          attachmentUrl:'',
          attachmentName:'',
        },
        educations: [],
        works: [],
        projects: [],
        personalFeature: {},
        joinProject:{},
      },
      modalFormRef:{},//组件ref
      label:'',//简历标签
      hHeight:'',//内容高度
      path:'addPersonnel',
      id:'',
      title:'人才',
      addPar:props.addPar,
      uploadVisible:false,//上传头像
      isShowPdf:false,
      openDetails:false,
      previewUrl:'',
      resumeUpload:{
        uploadFlie: [], //新上传文件
        uploadType: 'pdf/doc/docx', //上传-格式
        uploadSize: 10, //上传-大小
        uploadNum: 1, //上传数量
      },
      positionList:[],//加入项目下拉框

    })
    var {
      rules,
      addLabel,
      detLabel,
      saveLabel,
      delExperience,
      addExperience,
      disabledBase,
      addContact,
      delContact,
      disabledStartDate,
      disabledEndDate,
      openChange,
      changeEndDate,
      fieldSetList,
      genderList,
      salaryList,
      schoolList,
      maritalList,
      eduLevelList,
      eduLevelList1,
      searchCityhandle1,
      searchCityhandle,
      searchCityhandle2,
      searchTypehandle,
      searchIndusthandle,
      getDetail,
    } = getMixin(data)
    //保存按钮
    const router=useRouter()
    const $bus = getCurrentInstance().appContext.config.globalProperties.$bus
    const handleOk = () => {
        if(!newData.id && data.ruleForm.resume.attachmentUrl != '' && data.ruleForm.resume.city.length && (data.ruleForm.resume.cityId == ''||data.ruleForm.resume.cityId == undefined)){
          data.ruleForm.resume.cityId = data.ruleForm.resume.city[0]
        }
      data.modalFormRef.validateFields().then(()=>{
        data.loading = true
        var url;
        if(newData.id){
          url = updateResumeAPI
          data.ruleForm.resumeId = newData.id
        }else{
          url = addResumeAPI
          if(!data.ruleForm.resume.attachmentUrl){
            data.ruleForm.resume.attachmentUrl = data.resumeUpload.uploadFlie.length?data.uploadFlie.uploadFlie[0].attachmentUrl:''
            data.ruleForm.resume.attachmentName = data.resumeUpload.uploadFlie.length?data.uploadFlie.uploadFlie[0].attachmentName:''
          }
          // if(data.ruleForm.resume.attachmentUrl != '' && data.ruleForm.resume.city.length && (data.ruleForm.resume.cityId == ''||data.ruleForm.resume.cityId == undefined)){
          //   data.ruleForm.resume.cityId = data.ruleForm.resume.city[0]
          // }
        }
        if(data.ruleForm.resume.mails.length){
          let arr =[]
          data.ruleForm.resume.mails.forEach((item)=>{
            if(!validater.isEmpty(item)){
              arr.push(item)
            }
          })
          data.ruleForm.resume.mails = arr
        }
        if(data.ruleForm.resume.phones.length){
          let arr1 =[]
          data.ruleForm.resume.phones.forEach((item)=>{
            if(!validater.isEmpty(item)){
              arr1.push(item)
            }
          })
          data.ruleForm.resume.phones = arr1
        }
        url(data.ruleForm).then(res=>{
          data.loading = false
          if(res.success){
            message.success('保存成功');
            if(!isMax){
              $bus.emit('updateList')
              $bus.emit("changeResumeMenu", true);
            }
            closeMoadl()
            if(data.openDetails){
              let id =newData.id?newData.id:res.data
              var path = `personnelDetails?id=${id}`
            }else{
              path = `personnels`
            }
            router.push(path)
          }else{
            message.warning(res.message);
          }
        })
      }).catch((rep)=>{
        rep.errorFields.forEach((item,index)=>{
          item.index = index
          if(item.name.includes('resume')){
            item.sort = 1
          }else if(item.name.includes('works')){
            item.sort = 2
          }else if(item.name.includes('projects')){
            item.sort = 3
          }else if(item.name.includes('educations')){
            item.sort = 4
          }else if(item.name.includes('personalFeature')){
            item.sort = 5
          }else if(item.name.includes('joinProject')){
            item.sort = 6
          }
        })
        rep.errorFields.sort((a,b)=>{
          if(a.sort === b.sort){
            return a.index - b.index ;
          }
          return a.sort - b.sort ;
        })
        if(rep.errorFields[0].name.includes('personalFeature')){
          message.warning('请补全个人特色')
        }else if(rep.errorFields[0].name.includes('joinProject')){
          message.warning('请添加加入原因')
        }else if(rep.errorFields[0].name.includes('works')){
          message.warning('请补全工作经历')
        }else if(rep.errorFields[0].name.includes('projects')){
          message.warning('请补全项目经历')
        }else if(rep.errorFields[0].name.includes('educations')){
          message.warning('请补全教育经历')
        }else if(rep.errorFields[0].name.includes('resume')){
          message.warning('请补全基本信息')
        }
        data.modalFormRef.scrollToField(rep.errorFields[0].name)
      })
    }
    /**设置页面动态高度 */
    const setWinHeight = () => {
      nextTick(()=>{
        if(isMax){
          data.hHeight = document.documentElement.clientHeight - 100 +"px"
        }else{
          data.hHeight = document.documentElement.clientHeight - 250 +"px"
        }
      })//获取内容高度
    }
    onMounted(async() => {
      setWinHeight()
      window.addEventListener("resize", setWinHeight);
      
      if(newData.id && maxIndex == -1){
        getDetail(newData.id)
      }else{
        data.loadingEdit = false
      }

      if(data.ruleForm.resume.attachmentUrl){
        let obj ={
          attachmentUrl:data.ruleForm.resume.attachmentUrl,
          attachmentName:data.ruleForm.resume.attachmentName,
        }
        data.resumeUpload.uploadFlie.push(obj)
      }
        
    })

    onUnmounted(() => {
      window.removeEventListener("resize", setWinHeight);
    });
    //头像上传
    const closeCropper=(val)=>{
      data.uploadVisible = val
    }
    const headUpload=(url)=>{
      data.ruleForm.resume.headPhoto = url
    }

    const {
      isMax,
      closeMoadl,
      maxOperation,
      minOperation,
      newData,
      closeMax,
      maxIndex
    } = getAdd(data)

     //上传附件-子传值
    const fileUploadM = (arr,flg) => {
      data.resumeUpload.uploadFlie = []
      if (flg == 1) { //进度条
        data.resumeUpload.uploadFlie.unshift(arr);
      } else if (flg == 2) {
        data.resumeUpload.uploadFlie.unshift(arr);
        if(data.resumeUpload.uploadFlie.length){
          toResumeAnalysis(arr.attachmentUrl)
        }
        data.isShowPdf = data.resumeUpload.uploadFlie.length ?true:false
      }
    }
    //上传-删除后台文件
    const rightChaClick = (index) => {
      data.resumeUpload.uploadFlie.splice(index, 1);
      if(data.resumeUpload.uploadFlie.length == 0){
        data.isShowPdf = false
        data.ruleForm = {
          resume: {
            name:'',
            phones: [null],
            mails: [null],
            tags: [],
            expectCityIds:[],
            attachmentUrl:'',
            attachmentName:'',
          },
          educations: [],
          works: [],
          projects: [],
          personalFeature: {},
          joinProject:{},
        }
      }
    }
    //上传-预览
    const handlePreview=()=>{
      data.isShowPdf = true
      data.previewUrl = `${setFileUrl(data.resumeUpload.uploadFlie[0].attachmentUrl)}#toolbar=0`
    }

    //简历解析
    const toResumeAnalysis = (fileUrl)=>{
      let param ={
        fileUrl :fileUrl
      }
      resumeAnalysisAPI(param).then(res=>{
        if(res.success){
          data.previewUrl = `${setFileUrl(fileUrl)}#toolbar=0`
          data.ruleForm = res.data
          if(data.ruleForm.resume.city == null) {//所在城市
            data.ruleForm.resume.city = []
          }else {
            data.ruleForm.resume.city = [data.ruleForm.resume.city.id]
          }
          if(data.ruleForm.resume.expectCities == null) {//期望城市
            data.ruleForm.resume.expectCities = []
          }
          validater.isEmpty(data.ruleForm.resume.phones) ||data.ruleForm.resume.phones.length == 0?data.ruleForm.resume.phones= [null]:data.ruleForm.resume.phones
          validater.isEmpty(data.ruleForm.resume.mails) ||data.ruleForm.resume.mails.length == 0?data.ruleForm.resume.mails= [null]:data.ruleForm.resume.mails
          data.ruleForm.resume.tags = []
          data.ruleForm.joinProject={}
          data.ruleForm.resume.attachmentUrl = data.resumeUpload.uploadFlie.length?data.resumeUpload.uploadFlie[data.resumeUpload.uploadFlie.length-1].attachmentUrl:''
          data.ruleForm.resume.attachmentName = data.resumeUpload.uploadFlie.length?data.resumeUpload.uploadFlie[data.resumeUpload.uploadFlie.length-1].attachmentName:''
        }else{
          message.warning(res.message)
        }
      })
      
    }
    //获取职位下拉框
    const getProject = (keywords,type)=>{
      let param={
        pageNum:1,
        pageSize:999,
        keywords:type?keywords:'',
      }
      projectBoxListApi(param).then(res=>{
        if(res.success){
          data.positionList = res.data.records
        }
      })
    }
    //职位搜索
    const SearchProject=(keywords)=>{
      getProject(keywords,1)
    }
    return{
      ...toRefs(data),
      rules,
      handleOk,
      addLabel,
      detLabel,
      saveLabel,
      delExperience,
      addExperience,
      disabledBase,
      addContact,
      delContact,
      disabledStartDate,
      disabledEndDate,
      openChange,
      changeEndDate,

      isMax,
      newData,
      closeMoadl,
      maxOperation,
      minOperation,
      setPhoto,
      closeCropper,
      headUpload,
      fileUploadM,
      rightChaClick,
      handlePreview,
      fieldSetList,
      genderList,
      salaryList,
      schoolList,
      maritalList,
      eduLevelList,
      eduLevelList1,
      toResumeAnalysis,
      searchTypehandle,
      getProject,
      SearchProject,
      searchCityhandle1,
      searchCityhandle,
      searchCityhandle2,
      searchIndusthandle,
      closeMax,
      validater,
    }
  }
})
</script>
<style scoped src="@/assets/css/add.css" >
</style>
<style scoped>
.fromLast{
  margin: 24px 24px 0;
}
.fromLast .ant-form-item:last-of-type{
  margin-bottom: 0;
}
.isMax .fromLast{
  margin-left: 32px;
  margin-right: 32px;
}
.space-font2{
  margin-left: 34px;
}
::v-deep .salary-box .ant-form-item:nth-of-type(1){
  width: 50%;
  padding-right: 12px;
}
::v-deep .salary-box .ant-form-item:nth-of-type(2){
  width: 50%;
}
::v-deep .salary-box .ant-form-item-control-input-content{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.tag-box{
  width: 100%;
  min-height: 32px;
  border-radius: 4px;
  border: 1px solid #E8E8E8;
  padding: 4px 8px 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  background: #fff;
}
.tag-box:hover{
  border: 1px solid #507AFD;
  cursor: pointer;
}
.tag-box .ant-tag{
  background: #FFFFFF;
  border-radius: 12px;
  border: 1px solid #DCDFE6;
  font-size: 14px;
  color: #333;
  line-height: 22px;
  margin-bottom: 4px;
  margin-right: 4px;
  display: flex;
  align-items: center;
}
.tag-box input{
  background-color:transparent!important;
  border:none;
  padding: 0px;
  min-width: 90px;
  flex: 1;
  margin-bottom: 4px;
}
.tag-box .ant-tag span{
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
}
::v-deep .eduForm .ant-form-item-control-input-content,
::v-deep .timeForm .ant-form-item-control-input-content,
::v-deep .listForm .ant-form-item .ant-form-item-control-input-content{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/* ::v-deep .uploadContent .eduForm .ant-form-item-control-input-content{
  flex-wrap: wrap;
} */
::v-deep .listForm,::v-deep .timeForm,::v-deep .salary-box{
  margin-bottom:0;
}
::v-deep .timeForm .ant-checkbox + span{
  padding-right: 0;
}
::v-deep .timeForm .ant-form-item:not(:last-of-type){
  width: calc((100% - 26px)/2);
}
.deleteBtn,
.deleteBtn:hover,
.deleteBtn:focus,
.deleteBtn:active{
  width: 64px;
  height: 32px;
  background: #D9534F;
  border-radius: 4px;
  color: #FFFFFF;
  border: #D9534F;
  margin-left: 126px;
}
.delete-box{
  width: 100%;
  border-bottom: 1px solid #D9D9D9;
  padding-bottom: 24px;
  margin-bottom: 24px;
}
.add-box{
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  color: #507AFD;
  cursor: pointer;
  margin-top: -8px;
  margin-bottom: 8px;
}
.add-box svg{
  margin-right: 8px;
}
.listForm svg{
  margin-left: 12px;
  cursor: pointer;
}
.details-radio,.details-checkbox{
  white-space: nowrap;
  /* margin-left: 12px; */
}
.details-radio .ant-radio-wrapper{
  margin-right: 0;
}
::v-deep .details-radio span.ant-radio + *{
  padding-right:0px;
}
::v-deep .ant-radio-wrapper + .ant-radio-wrapper{
  margin-left: 12px;
}
.time-range{
  margin: 0 4px 16px;
}
::v-deep .ant-upload .ant-btn{
  color: #4F5B6E
}
/* 上传简历后样式 */
.uploadContent .custormForm{
  display: flex;
  overflow-y: visible;
}
.uploadContent .custormForm>div,.uploadContent >form{
  flex: 1;
  width: 50%;
  max-width: 50%;
}
.uploadContent .container_left{
  overflow-y: auto;
}
.uploadContent .container_right{
  padding-left: 12px;
  box-sizing: border-box;
}
/* .uploadContent div::-webkit-scrollbar-thumb{
  background: #fff;
} */
::v-deep .uploadContent .upload-tip{
  display: inline-block;
  margin-left:0px;
  margin-top: 8px;
}
.container_right{
  position: relative;
  padding-right: 16px;
  padding-bottom: 24px;
}
.pdfBtn{
  background: #507AFD;
  border-radius: 9px;
  color: #FFFFFF;
  height: 17px;
  font-size: 12px;
  line-height: 17px;
  padding: 0 8px;
  position: absolute;
  right: 40px;
  top: 16px;
  cursor: pointer;
}
/* 头像 */
.img-box img{
  width: 60px;
  height: 60px;
  border: 1px solid #DCDFE6;
  border-radius: 50%;
  margin-right: 16px;
}
.imgForm{
  display: flex;
  align-items: center;
}
/* 保存 */
::v-deep .btn-item{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
::v-deep .ant-picker.ant-picker-disabled{
  border-color: #d9d9d9!important;
  background: #f5f5f5!important;
}
::v-deep .clearError .ant-form-item-explain{
  display: none;
}
.right_text {
  margin-left: 8px;
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  line-height: 16px;
}
.isMax .uploadContent .ant-form{
  padding-bottom: 24px;
}
.custmoer-txt{
  color: #333;
}
::v-deep .flex-align{
  width: calc(100% - 16px);
}
.mr12{
  margin-right: 12px;
}
</style>